var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4998 5.33333V12M29.8332 8.66667H23.1665M7.40651 20.3947C5.72917 21.3787 1.33317 23.3853 4.01051 25.896C5.31984 27.1227 6.77584 28 8.60784 28H19.0585C20.8905 28 22.3478 27.1227 23.6545 25.896C26.3332 23.3853 21.9372 21.3773 20.2598 20.3947C18.3072 19.2626 16.0902 18.6664 13.8332 18.6664C11.5761 18.6664 9.35913 19.2626 7.40651 20.3947ZM19.1665 9.33333C19.1665 10.7478 18.6046 12.1044 17.6044 13.1046C16.6042 14.1048 15.2477 14.6667 13.8332 14.6667C12.4187 14.6667 11.0621 14.1048 10.0619 13.1046C9.06174 12.1044 8.49984 10.7478 8.49984 9.33333C8.49984 7.91885 9.06174 6.56229 10.0619 5.5621C11.0621 4.5619 12.4187 4 13.8332 4C15.2477 4 16.6042 4.5619 17.6044 5.5621C18.6046 6.56229 19.1665 7.91885 19.1665 9.33333Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.c1f8da1e6f87ce1ec64f8427a36aa46d.svg";
export { ForwardRef as ReactComponent };